// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8ca10c42","261":"24a38071","453":"fa86585c","667":"3d96c843","700":"522814e9","836":"0810ada4","972":"70aa5636","977":"dc8da868"}[chunkId] + ".chunk.js";
};